import type { ContextPanelPluginOptions } from '@atlaskit/editor-plugin-context-panel';

interface Props {
	options: Pick<ContextPanelPluginOptions, 'objectSideBar'> | undefined;
}

export function contextPanelPluginOptions({
	options,
}: Props): ContextPanelPluginOptions | undefined {
	if (!options) {
		return undefined;
	}

	return {
		objectSideBar: options.objectSideBar,
	};
}
